(($)=>{
    "use strict";
	$('a.sr-seal-img').on('click', function (event) {
		event.preventDefault();
		const $target = $( $(this).attr('href') );
		let margin = 100;
		if ( $(window).width() < 768 ) {
			margin = 50;
		}
    	if( $target.length ){
        	$( 'html, body' ).animate({
				scrollTop: ($target.offset().top - margin )
			}, 1000);
		}
	});

})(jQuery)